<template>
    <div>
        <b-button
            variant="warning"
            @click.stop="obterDotacoesProcesso()"
            :disabled="valorDisponivel == 0"
        >
            <span>
                <i class="fa fa-plus mr-2"></i> Obter Dotações do Processo
            </span>
        </b-button>
    </div>
</template>

<script>
import RequisicoesServicos from '../RequisicoesServicos'

export default {
    props: {
        valorDisponivel: {
            type: Number,
            default: () => 0
        },

        requisicao: {
            type: Object
        }
    },

    data() {
        return {
            dotacoes: []
        }
    },

    methods: {
        obterDotacoesProcesso() {
            this.$store.dispatch('addRequest')
            RequisicoesServicos.obterDotacoesProcesso(
                this.requisicao.idRequisicao
            ).then((response) => {
                if (response) {
                    if (response.success) {
                        this.dotacoes = [...response.data]
                        this.inserirDotacoes()
                    } else {
                        this.$toast.error(
                            response.errors[0],
                            'ERROR',
                            this.$toastConfig.error
                        )
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        inserirDotacoes() {
            for (let index = 0; index < this.dotacoes.length; index++) {
                const dotacao = this.dotacoes[index]
                let novoRateio = {
                    codUnidade: dotacao.vcCodUnidade,
                    unidade: dotacao.unidade,
                    codProjeto: dotacao.vcCodProjeto,
                    projeto: dotacao.projeto,
                    codAcao: dotacao.vcCodAcao,
                    acao: dotacao.acao,
                    nuValorRateio: this.valorDisponivel / this.dotacoes.length
                }
                this.$emit('inserirRateio', novoRateio)
            }
        }
    },

    created() {},

    computed: {},

    watch: {},

    validations: {}
}
</script>
